module.exports = __webpack_public_path__ + "static/media/Business.com_Logo.109d5f13.svg";